import React from 'react';
import Header from "./Header";
import Footer from "./Footer";
import humanOne from '../../assets/imgs/cherry-delivery.png';
import humanTwo from '../../assets/imgs/cherry-payment-processed.png';
import humanThree from '../../assets/imgs/sign-up-3.png';
import deliveryBox from '../../assets/imgs/deliverybox.svg';
import proServiceIcon from '../../assets/imgs/pro_service_icon.svg';
import courierRider from '../../assets/imgs/trackingImage.svg';
import star from '../../assets/imgs/star.svg';
import track from '../../assets/imgs/Track.svg';
import one from '../../assets/imgs/3.svg';
import two from '../../assets/imgs/1.svg';
import three from '../../assets/imgs/2.svg';

import {useForm} from "react-hook-form";
import {getErrorMessage} from "../../helpers/general_helper";
import OrderQuoteFormLandingPage from "./OrderQuoteFormLandingPage";


const Main = () => {
  const {register, handleSubmit, watch, errors} = useForm();

  const handleDeliveryTracking = (data) => {
    window.location.href = "track/" + data.tracking_number;
  };

  return (
    <div className="mainWrapper">
      <Header/>
      <div className="container">
        <div>
          <div className="row justify-content-center">
            <div className="homepage-header">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-5">
                    <ul className="list-unstyled">
                      <li>
                        <h2>We help you deliver your items, on demand, fast and securely</h2>
                      </li>
                      <li>
                        <p>Get a quick estimate to get started</p>
                      </li>
                      <li>
                        <OrderQuoteFormLandingPage/>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6 text-right">
                    <img src={deliveryBox} className={"img-fluid w-75"}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="landing-page-about-section">
        <div className="container">
          <div className={'row justify-content-center no-gutters'}>
            <div className={'col-md-11'}>
              <h2 className="mb-2">Why Use Zing?</h2>
              <div className="row justify-content-start mt-5">
                <div className="col-md-4">
                  <ul className="list-unstyled">
                    <li>
                      <img src={proServiceIcon} className="img-fluid" style={{width: 40}}/>
                    </li>
                    <li><p className={"mt-3 p-bold"}>Professional Service</p></li>
                    <li>
                      <small>
                        All delivery riders have been trained to adhere to treat you, your package and the receiver
                        with the
                        utmost respect you deserve
                      </small>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4">
                  <ul className="list-unstyled">
                    <li>
                      <img src={star} className="img-fluid" style={{width: 30}}/>
                    </li>
                    <li><p className={"mt-3 p-bold"}>Secured</p></li>
                    <li>
                      <small>
                        Your package is in safe hands. All riders have been carefully selected and trained to handle
                        your
                        package with utmost respect
                      </small>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4">
                  <ul className="list-unstyled">
                    <li>
                      <img src={track} className="img-fluid" style={{width: 40}}/>
                    </li>
                    <li><p className={"mt-3 p-bold"}>Real-time tracking</p></li>
                    <li>
                      <small>
                        Both package receiver can know exactly where the package is going with our real-time tracking
                        updates.
                      </small>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="landing-page-tracking-section" id="trackingSection">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-11">
              <div className="row justify-content-between">
                <div className="col-md-5 align-self-center">
                  <h2>Track your package</h2>
                  <br/>
                  <form onSubmit={handleSubmit(handleDeliveryTracking)}>
                    <div className="input-group">
                      <input type="text" className="form-control form-control-lg input-form"
                             ref={register({
                               required: true
                             })}
                             placeholder="Enter tracking number"
                             name={"tracking_number"}
                             aria-label="Username" aria-describedby="basic-addon1"/>
                      <div className="input-group-append">
                        <button className="btn btn-primary">Track</button>
                      </div>

                    </div>
                    {errors.tracking_number &&
                    <small className="small-text-red"> <i
                      className="fas fa-exclamation-triangle"/>{getErrorMessage(errors.tracking_number.type)}
                    </small>}
                  </form>
                </div>
                <div className="col-8 col-lg-6 col-xl-6 col-md-6 text-center">
                  <img src={courierRider} style={{height: 350}} className="img-fluid"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="landing-page-about-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-11">
              <h2 className="mb-2">How it works</h2>
              <div className="row justify-content-start mt-5">
                <div className="col-md-4">
                  <ul className="list-unstyled">
                    <li>
                      <img src={one} className="img-fluid" style={{width: 30}}/>
                    </li>
                    <li><p className={'mt-3 p-bold'}>Request</p></li>
                    <li>
                      <small>
                        You enter the packages location, destination, contents and the your mobile number
                      </small>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4">
                  <ul className="list-unstyled">
                    <li>
                      <img src={two} className="img-fluid"/>
                    </li>
                    <li><p className={'mt-3 p-bold'}>We pick up</p></li>
                    <li>
                      <small>
                        A delivery rider will contact you to pick up the package. You will be able to track every the
                        package
                        every step of the way
                      </small>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4">
                  <ul className="list-unstyled">
                    <li>
                      <img src={three} className="img-fluid"/>
                    </li>
                    <li><p className={'mt-3 p-bold'}>Its delivered</p></li>
                    <li>
                      <small>
                        All delivery riders have been trained to adhere to treat you, your package and the receiver with
                        the
                        utmost respect you deserve
                      </small>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="landing-page-mission-section">
        <div className='container'>
          <div className="row justify-content-center">
           <div className="col-md-11">
             <div className="text-left">
               <div className="row justify-content-start">
                 <div className="col-md-4 text-left">
                   <ul className="list-unstyled">
                     <li><h2 className={"colored-text"}>Who's Zing For?</h2></li>
                     <li>
                       <small className="pt-2">
                         Zing was built with these three(3) major actors in the delivery service cycle in
                         mind.
                       </small>
                     </li>
                   </ul>
                 </div>
               </div>
               <br/>
               <br/>
               <div className="row justify-content-between">
                 <div className="col-8 col-md-3 text-center">
                   <ul className="list-unstyled wiz-wrapper">
                     <li>
                       <img src={humanThree} className={"img-fluid"}/>
                     </li>
                     <li className={'mt-3'}>
                       <p className="p-bold">Business Owner</p>
                     </li>
                   </ul>
                 </div>
                 <div className="col-8 col-md-3 text-center">
                   <ul className="list-unstyled wiz-wrapper">
                     <li>
                       <img src={humanOne} className={"img-fluid"}/>
                     </li>
                     <li className={'mt-3'}>
                       <p className={'p-bold'}>
                         Courier Services
                       </p>
                     </li>
                   </ul>
                 </div>
                 <div className="col-8 col-md-3 text-center">
                   <ul className="list-unstyled wiz-wrapper">
                     <li>
                       <img src={humanTwo} className={"img-fluid"}/>
                     </li>
                     <li className={'mt-3'}>
                       <p className="p-bold">
                         Individuals
                       </p>
                     </li>
                   </ul>
                 </div>
               </div>
             </div>
           </div>
          </div>
        </div>
      </section>
      <Footer/>
    </div>
  );
}

export default Main;

